import React, { useState } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import Header from "./Navigation/Header";
import Footer from "./Footer/Footer";

const Layout = ({
  children,
  navigationStyle,
  hideHeader,
  hideFooter,
  pageType,
}) => {
  const [bodyOffset, setBodyOffset] = useState(0);
  return (
    <div>
      <Helmet>
        <script>
          {`(function (h,b) { var w = window, d = document, s = 'script', x, y; w['__hb_namespace'] = h; w[h] = w[h] || function () { (w[h].q=w[h].q||[]).push(arguments) }; y = d.createElement(s); x = d.getElementsByTagName(s)[0]; y.async = 1; y.src = b; x.parentNode.insertBefore(y,x) })('Homebot','https://embed.homebotapp.com/lgw/v1/widget.js'); Homebot('#homebot_homeowner', '48d485a0f997400670528d3be2a73cb73f3974a2fcdfe76b', {'size':'compact'})`}
        </script>
      </Helmet>
      <Header
        navigationStyle={navigationStyle}
        hideHeader={hideHeader}
        setBodyOffset={setBodyOffset}
        pageType={pageType}
      />
      <main id="body-content" style={{ paddingTop: bodyOffset + "px" }}>
        {children}
      </main>
      <Footer hideFooter={hideFooter} pageType={pageType} />
    </div>
  );
};

Layout.propTypes = {
  navigationStyle: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Layout;
